import { ORDER_METHODS } from '../../../../../../../services/exports/Constants';

export default {
  order_method_details: {
    title: '{{orderMethod}} {{waitingTime}} min kuluttua',
  },
  order_methods: {
    [ORDER_METHODS.DELIVERY]: 'Toimitus',
    [ORDER_METHODS.PICKUP]: 'Nouto',
    [ORDER_METHODS.ON_SITE]: 'Pöytätilaus',
  },
};
